import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Tracks page views on route changes.
 * Sends "Viewed" event to Mixpanel with page path and title.
 * Should be placed inside a RouterProvider context.
 */
const PageTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Send pageview event directly to Mixpanel
        if (window.mixpanel?.track) {
            window.mixpanel.track('Viewed', {
                path: location.pathname,
                title: document.title,
                referrer: document.referrer || undefined,
                search: location.search || undefined,
            });
        }
    }, [location.pathname]);

    return null;
};

export default PageTracker;
